module.exports = __webpack_public_path__ + "static/media/ship_maroon.3f73a60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_maroon.png
// module id = 204
// module chunks = 0